const styles = theme => ({
    buttonProgress: {
      position: 'absolute',
    },
  })
  
  export default styles
  